import React from "react"; 

const TextInput = (props) => {
  return (
      <input
        bsSize={props.bsSize}
        name={props.name}
        id={props.id}
        type={props.type}
        maxLength={props.maxLength}
        placeholder={props.placeholder}
        onChange={props.onChange}
        disabled={props.data ? props.data : props.disabled}
        defaultValue={props.defaultValue}
        value={props.value}
        onKeyUp={props.onKeyUp}
        onBlur={props.onBlur}
        onFocus={props.onFocus}
        style={props.style}
        //style={{borderColor:'#00aa7e'}}
        rows={props.rows}
      />
  );
};

export default TextInput;
